export enum UserTypeEnum {
    STAFFER = 'staffer',
    EMPLOYER = 'employer',
    MODERATOR = 'moderator'
}
